//import gsap from 'gsap'
//import Highway from './highway';

import stage from '../components/stage'
import lazySizes from 'lazysizes';
import gsap from 'gsap'
import Component from 'gia/Component';
import loadComponents from 'gia/loadComponents';
import removeComponents from 'gia/removeComponents';
import config from 'gia/config';

import Flickity from 'flickity'

import _each from 'lodash.foreach'
  //
  // import Textroll from './textroll'
  import Menu from './menu';
  import Video from './video';
  import Recruit from './recruit';
  import Form from './form';
  import Slide from './slide';
  import Eyes from './eyes';
  import Magnet from './magnet';
  import Tree from './tree';
  import Details from './details';
  import Journey from './journey';
  import Contact from './contact';
  // import Images from './images';
  // import Filmstrip from './filmstrip';
  // import Gallery from './gallery';
  // import Columns from './columns';
  // import Contact from './contact';
  // import CustomRenderer from './custom-renderer';
  // import CustomTransition from './custom-transition';
  // import HomeTransition from './home-transition';



// import 'es6-promise/auto';
// import owd from '../owd/owd';
//
// import '../components/cursor-mode';
// import '../components/cursor-theme';
// import CustomCursor from './custom-cursor';




class App {

  constructor($) {
    this.create()
  }

  create() {

    $('body').addClass('is-loaded')





    //config.set('log', false);

     const components = {
        Menu: Menu,
        Video: Video,
        Recruit: Recruit,
        Form: Form,
        Slide: Slide,
        Eyes: Eyes,
        Magnet: Magnet,
        Tree: Tree,
        Details: Details,
        Journey: Journey,
        Contact: Contact
    //   About: About,
    //   Images: Images,
    //   Filmstrip: Filmstrip,
    //   Gallery: Gallery,
    //   Columns: Columns,
    //   Textroll: Textroll
     }
    //
    //
    loadComponents(components)

    // this.resizeQue = this.resize.bind(this)
    // stage.on("stage:resize", this.resizeQue);
    // this.resize(stage)


    // _each($(".card--underline"), (el)=>{
    //
    //   const elm = el.querySelectorAll('.ll-under')[0]
    //   console.log(elm);
    //   const span = document.createElement('span')
    //   span.className = "cursor"
    //   elm.append(span)
    //   const cursor = elm.querySelectorAll('.cursor')[0]
    //   const length = (el.offsetWidth - 2*(el.offsetWidth - cursor.offsetLeft))*100 / el.offsetWidth;
    //   const underline = el.querySelectorAll('.underline')[0]
    //   underline.style.width = length + "%"
    //
    // })

      $('[data-popup]').on('click', (e)=>{

          const el = e.currentTarget
          const popup = el.dataset.popup
          const html = $(`#${popup}`).html()
          $('#popup-content').html(html)
          $('#popup').scrollTop(0)


          if(popup == "beni") {
            $('body').addClass('has-popup has-popup-grey')
          }
          else {
            $('body').removeClass('has-popup-grey')
            $('body').addClass('has-popup')
          }



          document.body.style.position = 'fixed';
          document.body.style.top = `-${stage.scrolltop}px`;

          loadComponents(components, $('#popup')[0])

          e.preventDefault()
      })

      $('#contact-button').on('click', (e)=>{
        //  e.preventDefault()
        $('body').removeClass('has-contact-sent')
          $('body').toggleClass('has-contact')
      })

      $('#contact-but').on('click', (e)=>{
         e.preventDefault()
         $('body').removeClass('has-contact-form-sent')
          $('body').toggleClass('has-contact-form')
      })

      $('#interest-button').on('click', (e) => {
        e.preventDefault()
        $('body').removeClass('has-interest-sent')
        $('body').toggleClass('has-interest')
      })

      $('.info-box').on('click', (e)=>{
          e.preventDefault()
          $('.info-box').not(e.currentTarget).removeClass('is-visible')

          $(e.currentTarget).toggleClass('is-visible')
      })

      $('[data-info]').on('click', (e)=>{

            const el = $(e.currentTarget).data('info')
            const pop = $(`[data-pop="${el}"]`)
            pop.addClass('is-visible')

      })

      $('[data-pop]').on('click',(e)=>{
            $('[data-pop]').removeClass('is-visible')
      })


      $('[data-js="popup-close"]').on('click', (e)=>{
          $('body').removeClass('has-popup has-popup-grey')
          removeComponents($('#popup')[0])

          const scrollY = document.body.style.top;
          document.body.style.position = '';
          document.body.style.top = '';
          window.scrollTo(0, parseInt(scrollY || '0') * -1);


      })

      // let storedMode = sessionStorage.getItem('announce');
      // if (!storedMode) {
      //     gsap.delayedCall(1, this.openAnounce.bind(this));
      //     sessionStorage.setItem('announce', 1);
      // }
      //
      // $('.anounce__close, .anounce__bkg').on('click', (e)=>{
      //     $('body').removeClass('has-anounce')
      //
      // })



    //  Kinder.concave();

    if($('.flickity-step').length){
      var flkty = new Flickity( '.flickity-step', {
        contain: true,
        cellAlign: 'left',
        watchCSS: true,
        prevNextButtons: true,
        pageDots: false
      });
    }




  }

  openAnounce() {

      $('body').addClass('has-anounce')

  }



  resize(){

  }
}

module.exports = App
